// extracted by mini-css-extract-plugin
export default {"container":"InfoCard_container__T3izB","flicker":"InfoCard_flicker__NnISn","loadSpin":"InfoCard_loadSpin__pyy9C","spinner":"InfoCard_spinner__ggnd6"};